<template>
  <div :class="classes" :style="styles">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'c-ct',
  props: {
    fluid: {
      type: Boolean,
      default: false
    },
    bgColor: {
      type: String,
      default: 'transparent'
    },
    experience: {
      type: Boolean,
      default: false
    },
    hasBorder: {
      type: Boolean,
      default: false,
    },
    borderColor: {
      type: String,
      default: '#074E8E',
    },
    borderWidth: {
      type: String,
      default: '1px'
    },
    borderRadius: {
      type: String,
      default: '5px'
    }
  },
  computed: {
    classes() {
      return [
        'ct-large',
        { 'ct-large--fluid': this.fluid },
        { 'ct-large--experience': this.experience },
        { 'ct-large--b-has-border': this.hasBorder }
      ]
    },
    styles() {
      return {
        background: this.bgColor,
        'border-color': this.hasBorder ? this.borderColor : '',
        'border-width': this.hasBorder ? this.borderWidth : '',
        'border-radius': this.hasBorder ? this.borderRadius : ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .ct-large {
    position: relative;
    padding: 0;

    &--fluid {
      width: 100%;
      max-width: 100%;
    }

    &--experience {
      padding-top: 30px;
      border: 1px solid red;

      &::before {
        content: '[ - container - ]';
        position: absolute;
        top: 0;
        font-size: 12px;
      }
    }

    &--b-has-border {
      border: solid 1px #074E8E;
    }
  }
</style>